(function () {
    "use strict";

    function EmailViewerController($scope, documentsService, fileitemService) {

        var vm = this;
        vm.cargando = true;

        vm.openAttachment = function (attachment) {

            if (!vm.isFilecontainer) {
                if (vm.idDrive) {
                    documentsService.viewDriveAttachment(vm.idDrive, vm.idDocument, attachment.cid, attachment.name);
                } else {
                    documentsService.viewAttachment(vm.idContenedor, vm.idDocument, attachment.cid, attachment.name);
                }
            } else {
                fileitemService.viewAttachment(vm.idContenedor, vm.idDocument, attachment.cid, attachment.name);
            }
        };

        function cargar() {
            if (!vm.isFilecontainer) {

                if (vm.idDrive) {
                    documentsService.viewDriveEmail(vm.idDrive, vm.idDocument)
                        .then(function (data) {
                            vm.emailInformation = data;
                            vm.cargando = false;
                        })
                        .catch(function (error) {
                            vm.emailInformation = {};
                            vm.cargando = false;
                            console.log(error);
                        });
                } else {
                    documentsService.viewEmail(vm.idContenedor, vm.idDocument)
                        .then(function (data) {
                            vm.emailInformation = data;
                            vm.cargando = false;
                        })
                        .catch(function (error) {
                            vm.emailInformation = {};
                            vm.cargando = false;
                            console.log(error);
                        });
                }
            } else {
                fileitemService.viewEmail(vm.idContenedor, vm.idDocument)
                    .then(function (data) {
                        vm.emailInformation = data;
                        vm.cargando = false;
                    })
                    .catch(function (error) {
                        vm.emailInformation = {};
                        vm.cargando = false;
                        console.log(error);
                    });
            }
        }

        function init() {
            vm.emailInformation = {};
            vm.cargando = true;
            cargar();
        }

        init();
    }

    EmailViewerController.$inject = ['$scope', 'solpheo.documentsService', 'solpheo.fileitemService'];

    angular.module('solpheo')
    .component('solpheoEmailViewer', {
        templateUrl: 'modules/documents/components/emailviewer/documents.emailviewer.template.html',
        controller: EmailViewerController,
        bindings: {
            idContenedor: '<',
            idDocument: '<',
            isFilecontainer: '<',
            idDrive: '<'
        }
    });

}());